import React from 'react'
import { TotalsCart } from 'components/Cart/components/TotalsCart'
import { Container } from './components/Styled'
import { TableHeader } from '../Styled'
import { CartData, CartSlice } from 'lib/core/data/quote/cart/types'

interface Props {
  abandonedCart?: {
    isFirstLoad: boolean
    isFetching: boolean
    isSuccess: boolean
    isFailure: boolean
    isCartException: boolean
    cartId: string
    count: number
    data?: CartData
  }
  cartRaw?: CartSlice
}

export const Totals = ({ abandonedCart, cartRaw }: Props) => {
  return (
    <Container>
      <TableHeader>Subtotal</TableHeader>
      <TotalsCart abandonedCart={abandonedCart} cartRaw={cartRaw} />
    </Container>
  )
}
